import React, { useEffect, useState } from 'react';
import { StepByStep } from '@gerdau/hefesto-mais-web';
import { Step } from '@gerdau/hefesto-mais-web/StepByStep/StepByStep.types';
import { useLocation } from 'react-router-dom';
import { EFabricationRoutes } from '../fabrication.routes';
import { Container } from './styles';

const FabricationTabs: React.FC = () => {
  const { pathname } = useLocation();
  const [currentTab, setCurrentTab] = useState(0);

  const steps: Step[] = [
    { label: 'Identificação da obra' },
    { label: 'Detalhamento do projeto' },
    { label: 'Itens extras' },
    { label: 'Revisão do pedido' }
  ];

  useEffect(() => {
    const currentPath = `/${pathname.split('/').pop()}`;
    const routes: EFabricationRoutes = currentPath as EFabricationRoutes;
    updateCurrentTab(routes);
  }, [pathname]);

  const updateCurrentTab = (path: EFabricationRoutes) => {
    const tabs: { [key in EFabricationRoutes]: number } = {
      [EFabricationRoutes.CONSTRUCTION_IDENTIFICATION]: 0,
      [EFabricationRoutes.LAST_ORDERS]: 0,
      [EFabricationRoutes.DETAILING_PROJECT]: 1,
      [EFabricationRoutes.EXTRA_ITENS]: 2,
      [EFabricationRoutes.CHECKOUT]: 3,
      [EFabricationRoutes.SUCCESS]: 4,
      [EFabricationRoutes.FABRICATION_REVIEW_ORDER]: 0
    };
    setCurrentTab(tabs[path] ?? 0);
  };

  return (
    <Container>
      <StepByStep steps={steps} activeStep={currentTab}></StepByStep>
    </Container>
  );
};

export default FabricationTabs;
